// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // login
  // baseUrl: 'http://192.168.10.185:9999/api',
  baseUrl: 'http://ats.deerak.com:8080/atsapp/api',

  // baseUrl: 'http://68.68.109.154:8080/atsapp/api',

  // baseUrl : "http://logskim.deerak.com:8085/logskim/api",
  // baseUrl: "http://stepinhr.com:8080/logskim/api",
  // baseUrl: 'http://70.35.202.45:8085/atsapp/api',

  // baseUrl : "http://beta.rotaryclubadambakkam.org:8080/logskim/api",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
